import * as React from 'react';

import { Outlet } from 'react-router-dom';

import AppNavigationWrapper from 'src/features/navigation/AppNavigationWrapper';
import { FallbackBlock } from 'src/registry/components/blocks/FallbackBlock';

const App = () => {
    return (
        <AppNavigationWrapper>
            <React.Suspense fallback={<FallbackBlock />}>
                <Outlet />
            </React.Suspense>
        </AppNavigationWrapper>
    );
};

export default App;
